import * as React from 'react';
// import { CodeBlock } from '../../../cookbook-ui/CodeBlock/CodeBlock';
import { AlertInlineMain } from '@inmoment/the-kitchen';
// import { convertArrayToTabBar } from './utils/tabBarFn';

export interface Props {}

// export const data1 = ['Example', 'AlertInlineMainButtons', 'ButtonObject'].map(convertArrayToTabBar);

export const AppTitleBarDocumentation: React.FC<Props> = (props) => {
  return (
    <div>
      <AlertInlineMain
        color="warning"
        title="AppTitleBar Click Events"
        subtitle="In order for 'onButtonClick' to fire, 'isTextButton' must be set to true. The icon click will also fire 'onButtonClick', and therefore relies on 'isTextButton'. These potentially will be renamed to be clearer in the future."
      />
      <br />
      <br />
    </div>
  );
};
